import { Create } from 'react-admin'

import AffiliatePaymentsForm from './AffiliatePaymentsForm'

const AffiliatePaymentsCreate = props => (
  <Create redirect="list" {...props}>
    <AffiliatePaymentsForm />
  </Create>
)

export default AffiliatePaymentsCreate
